import types from "./actionTypes";
import { dealWithUtilityFunctions } from '../../undoredo/actions'

export const onAddUtilityFunctions = (payload, noUndoRedo) => (dispatch, getState) => {

    if (noUndoRedo != true) dispatch(dealWithUtilityFunctions(payload, 'add'))

    dispatch({ type: types.ADD_UTILITY_FUNCTIONS, payload })

}

export const onDeleteUtilityFunctions = (payload, noUndoRedo) => (dispatch, getState) => {

    if (noUndoRedo != true) dispatch(dealWithUtilityFunctions(payload, 'delete'))

    dispatch({ type: types.DELETE_UTILITY_FUNCTIONS, payload })

}

export const onEditUtilityFunctions = (payload, noUndoRedo) => (dispatch, getState) => {

    if (noUndoRedo != true) dispatch(dealWithUtilityFunctions(payload, 'edit'))

    dispatch({ type: types.EDIT_UTILITY_FUNCTIONS, payload })

}

export const updateUtilityFunctions = (utilityFunctions) => ({
    type: types.UPDATE_UTILITY_FUNCTIONS,
    payload: utilityFunctions
})

export const resetUtilityFunctions = (utilityFunctions) => ({
    type: types.RESET_UTILITY_FUNCTIONS,
    payload: utilityFunctions
})
